import React from "react";

import moment from "moment";

import { useAiActionItemsUserSettingAndAcceptFlowIsOn } from "~/meetingRecorder/utils";

import { Views } from "../constants";
import { ActionItemsContext } from "../newActionItems/ActionItemsContext";
import type { GroupType } from "../types";

export const SYNTHETIC_AI_SUGGESTIONS_GROUP_NAME = "AI Suggestions";
export const AI_SUGGESTIONS_MAX_ITEMS = 5;

/**
 * This allows us to differentiate between our auto-generated "AI Suggestions" group and any user-created group with the
 * name "AI Suggestions". It's simpler to support both than validating the group names when they're created/modified.
 *
 * We can rely on the group ID, because any user-created group must have a db ID and the auto-generated one will default
 * to the name string.
 */
export function isGroupSyntheticAISuggestions(group: GroupType): boolean {
	return group.name === SYNTHETIC_AI_SUGGESTIONS_GROUP_NAME && group.id === SYNTHETIC_AI_SUGGESTIONS_GROUP_NAME;
}

export function wasCreatedWithinLastNDays(createdAt: string | null, n: number): boolean {
	if (createdAt == null) {
		return false;
	}
	const createdAtMoment = moment(createdAt);
	const nDaysAgo = moment().subtract(n, "days").startOf("day");
	return createdAtMoment.isSameOrAfter(nDaysAgo);
}

export function useShouldShowAISuggestions() {
	const aiActionItemsUserSettingIsOn = useAiActionItemsUserSettingAndAcceptFlowIsOn();
	const { view, filters } = React.useContext(ActionItemsContext);

	return aiActionItemsUserSettingIsOn && view === Views.USER && filters.showAIDetected;
}
